import { useEffect } from 'react'
import { usePlansContext } from '@mc/plans-ui'
import { useMCProExperiment } from '../../experiments/prcng-1194_v1_mc_pro_tier'

export const useDefaultPlanSelection = () => {
  const { selectedPlan, selectDuo, selectFamily, selectFamilyPlus } =
    usePlansContext()
  const { proSlot } = useMCProExperiment() // prcng-1266_v1

  useEffect(() => {
    if (selectedPlan) return

    if (proSlot === 'family') selectFamily()
    else if (proSlot === 'familyPlus') selectFamilyPlus()
    else selectDuo()
  }, [selectedPlan, proSlot, selectDuo, selectFamily, selectFamilyPlus])
}
